export type ChecklistItemStatuses = 'draft' | 'reviewed';
export type ExecutionItemStatuses =
  | 'pending'
  | 'input needed'
  | 'invalid'
  | 'completed'
  | 'error'
  | 'skipped';
export type ActionTaskTypes = 'automated task' | 'manual task';

interface StrategyStep {
  id: string;
  _id?: string; // MongoDB ID from server
  step: string;
  description: string;
}

export interface ChecklistItem {
  id: string;
  _id?: string; // MongoDB ID from server
  item: string;
  question: string;
  answer: string | null;
  status: ChecklistItemStatuses;
  warnings?: string[];
}

interface ExecutionParameter {
  name: string;
  label: string;
  value: string;
}

export interface ExecutionLink {
  href: string;
  label: string;
}

export interface ExecutionItem {
  id: string;
  _id?: string; // MongoDB ID from server
  item: string;
  type: ActionTaskTypes;
  status: ExecutionItemStatuses;
  function: string;
  parameters: ExecutionParameter[];
  details: string;
  results: string | null;
  response: string | null;
  links: ExecutionLink[];
}

interface Strategy {
  steps: StrategyStep[];
}

export interface Checklist {
  items: ChecklistItem[];
}

export interface Execution {
  items: ExecutionItem[];
}

export interface Result {
  id: string;
  cirra_organization_id?: string | null;
  cirra_user_id: string;
  sf_organization_id: string;
  sf_user_id: string;
  strategy: Strategy;
  checklist: Checklist;
  execution: Execution;
  external_id: string | null;
  key: string;
  name: string;
  summary: string;
  api_key_id: string;
  created_at: string;
  updated_at: string;
  last_active_at: string;
}

export type ChangeRequest = Result;

export interface ApiResponse {
  status: 'Completed' | 'draft' | 'pending';
  result: Result;
}

export enum RowPosition {
  ABOVE = 'above',
  BELOW = 'below',
}

export type AddRowItems = ChecklistItem | ExecutionItem;

export interface ChangeRequestGroup {
  key: string;
  label: string;
  changeRequests: Result[];
}
